import React from 'react'
import { FooterNewLP } from '@shared/components/footer'
import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'

import { MfoRefinanceScreen } from '../screens/mfo-refinance'

const LoanPage: NextPageFC<Empty, PageLayoutOwnProps> = () =>
	MfoRefinanceScreen({
		ratePoints: [
			'Обеспечим очень низкий платёж при сроке до 20 лет',
			'Ниже переплата по кредиту, потому что ставка по рефинансированию — от 14,9% годовых',
			'Маленький платёж после рефинансирование облегчит нагрузку на семейный бюджет',
			'Сможете вернуться к спокойной жизни с комфортным платежом',
			'Получите дополнительную сумму на любые цели до 300 тысяч рублей',
			'Не нужно платить комиссию кредитному брокеру, так как рефинансируете напрямую у кредитора',
		],
		minLoan: 5e5,
	})

LoanPage.layout = PageLayout
LoanPage.layoutProps = {
	menuProps: {
		hideLinksList: true,
	},
	customFooter: <FooterNewLP />,
}

LoanPage.headProps = {
	canonicalLink: 'https://credit.club/personal/na-refinansirovanie',
	title: 'Рефинансируйте микрокредиты под залог квартиры',
	description:
		'От 1 миллиона рублей ► Конкурентная ставка ► До 15 млн в день обращения ► Без скрытых комиссий и платежей',
	ogImageName: 'graph-loan.jpg',
}

export default LoanPage
